import React, {useEffect, useContext, useState} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../component/Header';
import TimeLine from '../../component/TimeLine';
import { AppContext } from '../../context/app-context';
import API from '../../helper/API';

const BookingTimeLine = () => {

    let { consultationId } = useParams();
    let navigate = useNavigate();
    const [state, dispatch] = useContext(AppContext);
    const [currentConsultation, setCurrentConsultation] = useState();
    const [timeLeft, setTimeLeft] = useState(null);

    useEffect(() => {
        const consultation = state.consultationList.find(obj => obj.consultationId === consultationId);
        if(consultation) {
            setCurrentConsultation(consultation);
            localStorage.setItem('isNotification', true);
        }else {
            API.get(`/user/consultations?userId=${state.user.userId}&status=pending`).then(response => {
                if(response?.data?.length > 0) {
                    setCurrentConsultation(response.data[0]);
                    localStorage.setItem('isNotification', true);
                }
            })
        }

        return () => {
            setTimeLeft(null);
        }

    }, []);

    useEffect(() => {
        const userUrl = `?userId=${state.user.userId}&name=${state.user.name}&gender=${state.user.gender}&age=${state.user.age}&height=${state.user.height}&weight=${state.user.weight}&groupId=${state.user.groupId}&appVersion=${state.user.appVersion}&osType=${state.user.osType}&token=${state.user.token}`;
        if(timeLeft===0){
            if(timeLeft !== null)
                navigate(`/${userUrl}`);
        }
        if (!timeLeft) return;
        const intervalId = setInterval(() => { setTimeLeft(timeLeft - 1); }, 1000);
        return () => clearInterval(intervalId);
        
    }, [timeLeft]);

    return (
        <div>
            <Header title="Instant Consult" isBookingNavDisplay={true} />
            { currentConsultation && <TimeLine currentConsultation={currentConsultation} doctorList={state.doctorList} setTimeLeft={setTimeLeft} /> }
            { timeLeft !== null && <div className='instruction-footer'>
                <p>Don’t press back or close screen. You will be redirected automatically in {timeLeft} seconds</p>
            </div> }
        </div>
    );
};

export default BookingTimeLine;